import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'competitions',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./competitions/competitions.module').then(m => m.CompetitionsModule)
  },
  {
    path: 'courses',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./courses/courses.module').then(m => m.CoursesModule)
  },
  {
    path: 'users',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
  },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuardService] },
  { path: '', component: HomeComponent, canActivate: [AuthGuardService] },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload' /*, enableTracing: true*/
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
